import { PerspectiveCamera, OrthographicCamera, MathUtils } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import Experience from "./Experience";

export default class Camera {
  constructor(isOrtographic = false, controlsEnabled = false) {
    this.experience = new Experience();
    this.config = this.experience.config;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.canvas = this.experience.canvas;
    this.targetElement = this.experience.targetElement;
    this.fov = 50;
    this.planeAspectRatio = 16 / 9;

    this.setInstance(isOrtographic);

    if (controlsEnabled) {
      this.setOrbitControls();
    }
  }

  setInstance(isOrtographic = false) {
    if (isOrtographic) {
      const frustumSize = 15;
      const aspect = this.config.height / this.config.width;
      this.instance = new OrthographicCamera(-0.5, 0.5, 0.5, -0.5, 0.1, 1000);
      this.instance.position.set(0, 0, -3);
      this.instance.lookAt(0, 0, 0);
      this.scene.add(this.instance);
    } else {
      this.instance = new PerspectiveCamera(
        35,
        this.config.width / this.config.height,
        0.1,
        100
      );
      this.instance.position.set(0, -0.4, 0.5);
      this.instance.lookAt(0, 0, 0);
      this.scene.add(this.instance);
    }
  }

  setOrbitControls() {
    this.controls = new OrbitControls(this.instance, this.canvas);
    this.controls.enableDamping = true;
  }

  resize() {
    this.instance.aspect = this.config.width / this.config.height;
    this.instance.updateProjectionMatrix();
  }

  update() {
    if (this.controls) {
      this.controls.update();
    }
  }
}
